import React, { useState } from 'react';
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import { useTheme } from '../contexts/ThemeContext';
import PoweredBy from '../components/PoweredBy/PoweredBy';
import './LoginPage.css';

function LoginPage() {
    const { instance } = useMsal();
    const { isDark } = useTheme();
    const [loading, setLoading] = useState(false);

    const handleLogin = () => {
        setLoading(true);
        instance.loginPopup(loginRequest).catch(e => {
            if (import.meta.env.DEV) {
                console.error(e);
            }
            setLoading(false);
        });
    };

    return (
        <div className="login-page">
            {/* Background glow */}
            <div className="login-bg-gradient" aria-hidden="true" />

            <div className="login-card">
                {/* Top accent bar */}
                <div className="login-card-accent" />
                
                <div className="login-card-content">
                    <img 
                        src="/logo_redeancora.png" 
                        alt="Rede Âncora" 
                        className="login-logo" 
                    />
                    
                    <div className="login-header">
                        <h1 className="login-title">Dashboard Executivo</h1>
                        <p className="login-subtitle">
                            Análise financeira e indicadores estratégicos
                        </p>
                    </div>

                    <div className="login-divider">
                        <span className="login-divider-text">Acesso Corporativo</span>
                    </div>

                    <button 
                        onClick={handleLogin} 
                        className={`login-btn ${loading ? 'login-btn--loading' : ''}`}
                        disabled={loading}
                    >
                        {loading ? (
                            <div className="login-spinner" />
                        ) : (
                            <>
                                <svg width="20" height="20" viewBox="0 0 21 21" className="login-btn-icon" aria-hidden="true">
                                    <path fill="#f25022" d="M1 1h9v9H1z"/>
                                    <path fill="#7fba00" d="M11 1h9v9h-9z"/>
                                    <path fill="#00a4ef" d="M1 11h9v9H1z"/>
                                    <path fill="#ffb900" d="M11 11h9v9h-9z"/>
                                </svg>
                                <span>Entrar com a Microsoft</span>
                            </>
                        )}
                    </button>

                    <p className="login-footer">
                        Ambiente seguro · Azure AD SSO
                    </p>
                </div>
            </div>

            <PoweredBy className="powered-by--login" />
        </div>
    );
}

export default LoginPage; 